export default function() {
  return {
    loading: false,
    cmsPages: {},
  }
}
